import {
  Card,
  CardContent,
  Typography,
  Chip,
  Avatar,
  Box,
  Button,
  TextField,
  MenuItem,
  Stack,
} from "@mui/material";
import { formatDistanceToNow, parseISO } from "date-fns";
import { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import TaskDetailsModal from "../../tasks/TaskDetailsModal";

const priorityColor = {
  High: "error",
  Medium: "warning",
  Low: "info",
};

const UpcomingTasks = ({ tasks = [], onTaskReorder, onViewAll }) => {
  const [search, setSearch] = useState("");
  const [selectedTask, setSelectedTask] = useState(null);
  const [taskList, setTaskList] = useState(tasks);

  const filtered = taskList.filter((task) =>
    task.title.toLowerCase().includes(search.toLowerCase())
  );

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const reordered = Array.from(taskList);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    setTaskList(reordered);

    if (onTaskReorder) onTaskReorder(reordered);
  };

  return (
    <>
      <Card elevation={3} sx={{ borderRadius: 3 }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography variant="h6">Upcoming Tasks</Typography>
            {onViewAll && <Button onClick={onViewAll}>View All</Button>}
          </Box>

          <TextField
            fullWidth
            size="small"
            label="Search tasks"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{ mb: 2 }}
          />

          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="taskList">
              {(provided) => (
                <Stack
                  spacing={2}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  {filtered.map((task, index) => (
                    <Draggable
                      key={task.id}
                      draggableId={task.id}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <Box
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          p={2}
                          borderRadius={2}
                          boxShadow={snapshot.isDragging ? 3 : 1}
                          bgcolor="background.paper"
                          onClick={() => setSelectedTask(task)}
                          sx={{ cursor: "pointer" }}
                        >
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Typography variant="subtitle1" fontWeight="bold">
                              {task.title}
                            </Typography>
                            <Chip
                              label={task.priority}
                              color={priorityColor[task.priority]}
                              size="small"
                            />
                          </Box>

                          <Typography variant="body2" color="text.secondary">
                            Due{" "}
                            {formatDistanceToNow(parseISO(task.dueDate), {
                              addSuffix: true,
                            })}
                          </Typography>

                          <Box
                            display="flex"
                            alignItems="center"
                            gap={1}
                            mt={1}
                          >
                            {task.assignedTo?.avatar && (
                              <Avatar
                                src={task.assignedTo.avatar}
                                alt={task.assignedTo.name}
                              />
                            )}
                            <Typography variant="body2">
                              {task.assignedTo?.name}
                            </Typography>
                          </Box>
                        </Box>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </Stack>
              )}
            </Droppable>
          </DragDropContext>
        </CardContent>
      </Card>

      <TaskDetailsModal
        open={!!selectedTask}
        task={selectedTask}
        onClose={() => setSelectedTask(null)}
      />
    </>
  );
};

export default UpcomingTasks;
